import { faRectanglesMixed } from "@fortawesome/pro-duotone-svg-icons";
import { Icon } from "@progress/kendo-react-common";
import {
  InputClearValue,
  InputPrefix,
  InputSeparator,
  TextBox,
} from "@progress/kendo-react-inputs";
import { isGalleryEditor } from "../../Template/NewTemplateSignals";
import { conditionalFormattingVisibility } from "../Store/CommonSignals";
import { ColorChangingIcon } from "../UI/ColorChangingIcon";

const ConditionalFormatPrefix = (_isGalleryEditor) => {
  return (
    <>
      <InputPrefix>
        <ColorChangingIcon
          icon={faRectanglesMixed}
          initialPrimaryColor="#605e5c"
          initialSecondaryColor="#0078D4"
          margin="1px 5px 0 5px"
          onClick={(e) => {
            e.stopPropagation();
            conditionalFormattingVisibility.value = true;
            isGalleryEditor.value = _isGalleryEditor;
          }}
        />
      </InputPrefix>
      <InputSeparator
        style={{
          width: "1px",
          backgroundColor: "gainsboro",
          margin: "4px 0px",
        }}
      />
    </>
  );
};

const ConditionalFormatSuffix = ({ handlePropertyChange }) => {
  return (
    <>
      <InputSeparator
        style={{
          width: "1px",
          backgroundColor: "gainsboro",
          margin: "4px 0px",
        }}
      />
      <InputClearValue
        onClick={() => handlePropertyChange({ propName: "ConditionalFormatting", propValue: [] })}
      >
        <Icon name="x" />
      </InputClearValue>
    </>
  );
};

export const ConditionalFormatInput = ({
  handlePropertyChange,
  currentPropertyValues,
  isGalleryEditor,
}) => {
  const ruleCount = currentPropertyValues?.ConditionalFormatting?.length || 0;

  let textString;
  if (ruleCount === 1) {
    textString = "1 Conditional Rule";
  } else if (ruleCount > 1) {
    textString = `${ruleCount} Conditional Rules`;
  } else {
    textString = null;
  }

  return (
    <TextBox
      name={"Expression"}
      label={"Expression"}
      placeholder="No conditional formatting rules"
      readOnly={true}
      value={textString}
      prefix={() => ConditionalFormatPrefix(isGalleryEditor)}
      suffix={() =>
        ConditionalFormatSuffix({
          handlePropertyChange,
        })
      }
    />
  );
};

export default ConditionalFormatInput;
